import { setConsentFactory, type ConsentMode } from '@pflegia/analytics/ui/consent/set-consent-factory';

export const setGoogleAndUetConsentModes = (
  consentModesToSet: ConsentMode[],
  { shouldSetUetConsent = true, startTime = Date.now() }: { shouldSetUetConsent?: boolean; startTime?: number } = {},
) => {
  setConsentFactory({
    manager: 'gtag',
    consentStorageKeys: ['ad_storage', 'analytics_storage', 'ad_personalization', 'ad_user_data'],
    consentModesToSet,
    startTime,
    fallBackHandler: () => {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function (...args: unknown[]) {
        window.dataLayer.push(args);
      };
    },
  });
  if (!shouldSetUetConsent) return;
  setConsentFactory({
    manager: 'uetq',
    handler: 'push',
    consentStorageKeys: ['ad_storage'],
    consentModesToSet,
    startTime,
    fallBackHandler: () => {
      window.uetq = window.uetq || [];
    },
    additionalCheck: () => window.uetq?.uetLoaded && window.uetq?.uetInstance?.uetLoaded,
  });
};
